import crypto from 'crypto';

const algorithm = 'aes-256-ctr';
const secretKey = process.env.NEXT_PUBLIC_PASSWORD_KEY ?? '';

export const encrypt = (data: unknown) => {
  const text = typeof data === 'string' ? data : JSON.stringify(data);
  const iv = crypto.randomBytes(16);

  const cipher = crypto.createCipheriv(algorithm, secretKey, iv);

  const encrypted = Buffer.concat([cipher.update(text), cipher.final()]);

  return iv.toString('hex') + '-' + encrypted.toString('hex');
};

export const decrypt = (hash: string) => {
  const hashSplitted = hash.split('-');
  const iv = hashSplitted?.at(0) ?? '';
  const content = hashSplitted?.at(1) ?? '';

  if (!iv || !content) return '';

  const decipher = crypto.createDecipheriv(algorithm, secretKey, Buffer.from(iv, 'hex'));

  const decrpyted = Buffer.concat([decipher.update(Buffer.from(content, 'hex')), decipher.final()]);

  return decrpyted.toString();
};
